// Vendor imports
const Immutable = require('immutable')
const Redux = require('redux')
const thunkMiddleware = require('redux-thunk').default
// Client V2 common imports
const routerMiddleware = require('client-v2/common/state/router/middleware')

module.exports = configureStore

function configureStore(options = {}) {
  let initialState = options.state
  if (typeof options.reviver === 'function' && initialState) {
    initialState = Immutable.fromJS(initialState, options.reviver)
  }
  return Redux.createStore(
    options.reducer,
    initialState,
    configureEnhancers(options)
  )
}

function configureEnhancers(options = {}) {
  let composeEnhancers = Redux.compose
  const middlewares = [
    thunkMiddleware,
    routerMiddleware,
    ...(options.middlewares || [])
  ]
  // Determine if this is running in a web browser
  if (typeof window !== 'undefined') {
    // Setup Redux DevTools Browser Extension (if installed)
    if ('__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' in window) {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  return composeEnhancers(
    Redux.applyMiddleware(...middlewares)
  )
}
